import React from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import lessonImg from "../images/lessonPlan.png";
import reportImg from "../images/report.png";
import "../../common/planTheme.css";
import "./Home.css";

const Home = () => {
  let { sid, userid } = useParams();

  return (
    <div className="lp-scope lessonHome-container">
      <div className="lessonHome-tiles">
        <Link
          to={`/lessonPlan/${sid}/${userid}`}
          className="lp-tile lessonHome-tile"
          aria-label="Lesson Plan"
        >
          <span className="lessonHome-iconWrap">
            <img className="lessonHome-icon" src={lessonImg} alt="" />
          </span>
          <h4 className="lessonHome-title">Lesson Plan</h4>
        </Link>
        <Link
          to={`/report/${sid}/${userid}`}
          className="lp-tile lessonHome-tile"
          aria-label="Report"
        >
          <span className="lessonHome-iconWrap">
            <img className="lessonHome-icon" src={reportImg} alt="" />
          </span>
          <h4 className="lessonHome-title">Report</h4>
        </Link>
      </div>
    </div>
  );
};

export default Home;
